module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/book",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("HOW TO USE THIS BOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Choosing Your Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Learning the Basics")]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7"
    }
  })]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Making the Hat")])]), _vm._v(" "), _c('p', {
    staticClass: "toccs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Pattern")])])]), _vm._v(" "), _c('p', {
    staticClass: "toccss"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knitting the Brim")])]), _vm._v(" "), _c('p', {
    staticClass: "toccss"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knitting the Body")])]), _vm._v(" "), _c('p', {
    staticClass: "toccss"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knitting the Top")])]), _vm._v(" "), _c('p', {
    staticClass: "toccs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Modifications")])])]), _vm._v(" "), _c('p', {
    staticClass: "toccss"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ribbed Brim")])]), _vm._v(" "), _c('p', {
    staticClass: "toccss"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stripes")])]), _vm._v(" "), _c('p', {
    staticClass: "toccss"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pom-pom")])]), _vm._v(" "), _c('p', {
    staticClass: "toccst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toccs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/resources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OTHER RESOURCES")])]), _vm._v(" "), _c('p', {
    staticClass: "toccs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0